import React, { useState } from 'react'
import CloseSvg from '../../assets/svg/CloseSvg'
import FirstPopupTab from './FirstPopupTab';
import SecondPopupTab from './SecondPopupTab';

const FilmCardPrePopup = ({ closePopup, img, title, time, date, centers, flags, vip_status, pufik_lang }) => {
  const [activeTab, setActiveTab] = useState(1);
  const tabTexts = {
    1: 'Öz avtomobilinizlə',
    2: 'Kirayə avtomobil',
    // 3: 'Pufik',
  };

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-main rounded-[12px] p-4 max-w-lg w-full">
        <div className="flex justify-between items-center">
          <h2 className="text-xl text-purple font-bold">{title}</h2>
          <button onClick={closePopup} className="text-xl text-red-600">
            <CloseSvg />
          </button>
        </div>
        <div className="grid grid-cols-2 gap-4 my-4">
          <button
            className="bg-purple text-white font-semibold p-[10px_6px] rounded-[8px]"
            onClick={() => setActiveTab(1)}
          >
            {tabTexts[1]}
          </button>
          <button
              className="bg-blue text-white font-semibold p-[10px_6px] rounded-[8px]"
              onClick={() => setActiveTab(2)}
            >
              {tabTexts[2]}
            </button>
          {/* {centers !== 'Buzovna' && (
            <>
            <button
              className="bg-blue text-white font-semibold p-[10px_6px] rounded-[8px]"
              onClick={() => setActiveTab(3)}
            >
              {tabTexts[3]}
            </button>
            </>
            
          )} */}
        </div>
        <p className="text-xl text-white font-bold mb-4">{tabTexts[activeTab]}</p>
        <div>
            {activeTab === 1 && <FirstPopupTab title={title} time={time} date={date} centers={centers} vip_status={vip_status}/>}
            {activeTab === 2 && <SecondPopupTab title={title} time={time} date={date} centers={centers} />}
            {/* {activeTab == 3 && <ThirdPopupTab title={title} time={time} date={date} centers={centers} pufik_lang={pufik_lang}/>} */}
        </div>
      </div>
    </div>
  );
};

export default FilmCardPrePopup;
